const PT = require("prop-types");
const React = require("react");
const _ = require("lodash");
const createReactClass = require("create-react-class");

const withOfficeErrorCatching = require("../core/hoc/withOfficeErrorCatching");
const withVaultDispatch = require("../core/hoc/withVaultDispatch");
const withVaultUpdate = require("../core/hoc/withVaultUpdate");
const AT = require("../core/vault/ActionTypes");
const {
	atSchool,
	atClasses,
	atStudents,
	atSchoolAccountClass,
} = require("../core/vault/StateCursors");
const OpsSchool = require("./vault/OpsSchool");
const ReportClasses = require("./ReportClasses");
const ReportStudents = require("./ReportStudents");
const ReportSchools = require("./ReportSchools");
const LoadGuard = require("../core/view/LoadGuard");
const Link = require("../core/view/Link");
const {getFormattedData} = require("../core/vault/MultiSlots");
const ArrowIcon = require("../core/view/ArrowIcon");
const URLMake = require("../../shared/URLMake");
const {
	getAdjacentClasses,
	getAdjacentSchools,
	getAdjacentStudents,
} = require("./util/ReportsUtil");
const ClassesUtil = require("./util/ClassesUtil");
const HoverText = require("../core/view/HoverText");
const CopyTable = require("./data/CopyTable");
const ReportBodyHeader = require("./ReportBodyHeader");
const ReportProblems = require("./ReportProblems");
const OfficeModal = require("../office/modals/OfficeModal");
const Breadcrumbs = require("./Breadcrumbs");

const styles = require("./styles/ReportBody.css");

const getPropsFromVault = function(props, vaultState) {
	const schoolState = atSchool(vaultState).get();

	const purchaseYear = OpsSchool.getPurchaseYear(schoolState);
	const purchaseYears = _.get(schoolState, "accounts.purchaseYears");

	// Because we're controlling year in the state, we're going to grab loaded
	// data a bit differently than other MultiSlot patterns. More specifically,
	// we're going to grab the entire object at the multislot keylist instead of
	// ones we're interested in because we don't know from the props what they are
	const classes = atClasses(vaultState).get() || {};
	const students = atStudents(vaultState).get() || {};

	if (!_.isEmpty(classes)) {
		// Grab the active student IDs from the class in the vaultState so that the
		// updated total can be seen without a page refresh
		_.each(classes, (c, cid) => {
			if (c.status === "done") {
				c.data.activeStudentIDs = atSchoolAccountClass(vaultState, cid).getIn(
					"activeStudentIDs"
				);
			}
		});
	}

	return {
		schoolState,
		mainAccountLoad: OpsSchool.getAccountsLoad(schoolState),
		studentsAccountLoad: OpsSchool.getAccountsStudentsLoad(schoolState),
		purchaseYears,
		currentYear: purchaseYear,
		students,
		classes,
	};
};

// Helper to apply higher-order components.
const augment = function(Component) {
	Component = withOfficeErrorCatching(Component);
	Component = withVaultDispatch(Component);
	Component = withVaultUpdate(Component, getPropsFromVault);
	return Component;
};

module.exports = augment(
	createReactClass({
		displayName: "ReportBody",

		propTypes: {
			user: PT.object.isRequired,
			tab: PT.string,
			pageData: PT.object,

			// Injected by HOCs
			dispatch: PT.func.isRequired,
			schoolState: PT.object.isRequired,
			students: PT.object.isRequired,
			classes: PT.object.isRequired,
			mainAccountLoad: PT.object.isRequired,
			studentsAccountLoad: PT.object.isRequired,
			purchaseYears: PT.array.isRequired,
			currentYear: PT.number,
		},

		getInitialState: function() {
			const {pageData} = this.props;
			const {classID, studentID} = pageData || {};
			return {
				days: classID || studentID ? "all" : "week",
				yearFilter: null,
				levelFilter: null,
				gradeFilter: null,
				showProblemModal: false,
				showProblemProps: null,
			};
		},

		vaultEvents: {
			showReportProblemModal: function(props) {
				this.setState({
					showProblemModal: true,
					showProblemProps: props,
				});
			},
		},

		componentDidUpdate: function(prevProps) {
			if (!_.isEqual(prevProps.pageData, this.props.pageData)) {
				this.onClose();
			}
		},

		onClose: function() {
			this.setState({
				showProblemModal: false,
				showProblemProps: null,
			});
		},

		getFilterState: function() {
			return _.pick(this.state, [
				"days",
				"yearFilter",
				"levelFilter",
				"gradeFilter",
			]);
		},

		loadClasses: function(classIDs) {
			this.props.dispatch({
				type: AT.LOAD_REPORT_CLASSES_SLOT_REQUEST,
				classIDs,
			});
		},

		loadStudents: function(studentIDs) {
			this.props.dispatch({
				type: AT.LOAD_REPORT_STUDENTS_SLOT_REQUEST,
				studentIDs,
			});
		},

		loadAccountMain: function() {
			this.props.dispatch({
				type: AT.LOAD_SCHOOL_ACCOUNTS_REQUEST,
			});
		},

		loadAccountStudents: function() {
			this.props.dispatch({
				type: AT.LOAD_SCHOOL_ACCOUNTS_STUDENTS_REQUEST,
			});
		},

		renderUnassigned: function() {
			return (
				<div className={styles.unassignedMessage}>
					{CopyTable.getUnassignedContactAdminCopy()}
				</div>
			);
		},

		renderEmpty: function(type, dueToFilters) {
			let createNew;
			const staffRoles = _.get(this.props.user, "model.staffRoles", {});
			if (
				(staffRoles.adminPurchase ||
					_.get(staffRoles, "adminSchoolIDs.length")) &&
				type === "classes" &&
				!dueToFilters
			) {
				createNew = (
					<p>
						You can create new classes on the{" "}
						<Link to={URLMake.forClassAccount()} className={styles.link}>
							Accounts
						</Link>{" "}
						page.
					</p>
				);
			}
			return (
				<div className={styles.empty}>
					There are currently no {type}
					{dueToFilters ? " that match all filters" : ""}.{createNew}
				</div>
			);
		},

		renderStudents: function() {
			const {
				user,
				pageData,
				schoolState,
				tab,
				purchaseYears,
				currentYear,
			} = this.props;
			const {schoolID, studentID} = pageData;
			const {yearFilter, levelFilter, gradeFilter} = this.state;
			const purchaseYear = OpsSchool.getPurchaseYear(schoolState);
			const year = parseInt(yearFilter || purchaseYear);
			let students = getFormattedData(this.props.students);
			if (!studentID) {
				students = _.filter(students, s => {
					if (!s.class.year) return true;
					return s.class.year === year;
				});
				if (schoolID) {
					students = _.filter(
						students,
						s => _.get(s, "school.id") === parseInt(pageData.schoolID)
					);
				}
				if (levelFilter) {
					students = _.filter(
						students,
						s => s.gradeID === parseInt(levelFilter)
					);
				}
				if (gradeFilter) {
					students = _.filter(
						students,
						s => _.get(s, "class.displayedGrade") === parseInt(gradeFilter)
					);
				}
				if (_.isArray(students)) students = _.keyBy(students, s => s.userID);
			}

			const availableLevels = _.uniq(_.map(students, s => s.gradeID));
			const availableGrades = _.uniq(
				_.map(students, s => _.get(s, "class.displayedGrade"))
			).sort((a, b) => a - b);
			let studentsEl;
			if (OpsSchool.isTeacherWithoutClasses(schoolState, user.userID)) {
				studentsEl = this.renderUnassigned();
			} else if (_.isEmpty(students)) {
				// assume they haven't set up classes if they have only one purchase year and no students in the purchase year.
				const noSetup =
					purchaseYears.length === 1 &&
					purchaseYears[0] === currentYear &&
					_.isEmpty(_.filter(students, c => c.year === currentYear));
				studentsEl = this.renderEmpty("students", !noSetup);
			} else {
				studentsEl = (
					<ReportStudents
						user={user}
						pageData={pageData}
						students={students}
						filters={this.getFilterState()}
						updateFilter={this.updateFilter}
						currentYear={currentYear}
					/>
				);
			}

			return (
				<div className={styles.reportOuter}>
					<div className={styles.navOuter}>
						<Breadcrumbs
							schoolState={schoolState}
							tab={tab}
							user={user}
							pageData={pageData}
							forReport={true}
						/>
						{this.makeNav()}
					</div>
					<div className={styles.reportInner}>
						{this.renderBodyHeader({
							studentsData: students,
							availableYears: purchaseYears,
							availableLevels,
							availableGrades,
							tab: "students",
						})}
						{studentsEl}
					</div>
				</div>
			);
		},

		renderClasses: function() {
			const {
				user,
				pageData,
				tab,
				schoolState,
				purchaseYears,
				currentYear,
			} = this.props;
			const {classID} = pageData;
			const {yearFilter, levelFilter, gradeFilter} = this.state;
			const purchaseYear = OpsSchool.getPurchaseYear(schoolState);
			const year = (yearFilter && parseInt(yearFilter)) || purchaseYear;
			let classes = getFormattedData(this.props.classes);

			if (!classID) {
				classes = _.filter(classes, c => c.year === year);
				if (pageData.schoolID) {
					classes = _.filter(
						classes,
						c => _.get(c, "school.id") === parseInt(pageData.schoolID)
					);
				}
				if (levelFilter) {
					classes = _.filter(classes, s => s.gradeID === parseInt(levelFilter));
				}
				if (gradeFilter) {
					classes = _.filter(
						classes,
						c => c.displayedGrade === parseInt(gradeFilter)
					);
				}
				if (_.isArray(classes)) classes = _.keyBy(classes, c => c.classID);
			}

			const availableLevels = _.uniq(_.map(classes, c => c.gradeID));
			const availableGrades = _.uniq(
				_.map(classes, c => c.displayedGrade)
			).sort((a, b) => a - b);

			let classesEl;
			if (OpsSchool.isTeacherWithoutClasses(schoolState, user.userID)) {
				classesEl = this.renderUnassigned();
			} else if (_.isEmpty(classes)) {
				// Purchase has no classes if they have no classes in the current year
				const noSetup =
					purchaseYears.length === 1 &&
					purchaseYears[0] === currentYear &&
					_.isEmpty(_.filter(classes, c => c.year === currentYear));
				classesEl = this.renderEmpty("classes", !noSetup);
			} else {
				classesEl = (
					<ReportClasses
						user={user}
						pageData={pageData}
						classes={classes}
						filters={this.getFilterState()}
						updateFilter={this.updateFilter}
						schoolState={this.props.schoolState}
					/>
				);
			}

			return (
				<div className={styles.reportOuter}>
					<div className={styles.navOuter}>
						<Breadcrumbs
							schoolState={schoolState}
							tab={tab}
							user={user}
							pageData={pageData}
							forReport={true}
						/>
						{this.makeNav()}
					</div>
					<div className={styles.reportInner}>
						{this.renderBodyHeader({
							classesData: classes,
							availableYears: purchaseYears,
							availableLevels,
							availableGrades,
							tab: "classes",
						})}
						{classesEl}
					</div>
				</div>
			);
		},

		renderSchools: function() {
			const {user, pageData, schoolState, tab} = this.props;
			const classes = getFormattedData(this.props.classes);
			const schoolsReports = OpsSchool.isTeacherWithoutClasses(
				schoolState,
				user.userID
			) ? (
				this.renderUnassigned()
			) : (
				<ReportSchools
					user={user}
					pageData={pageData}
					classes={classes}
					filters={this.getFilterState()}
					updateFilter={this.updateFilter}
				/>
			);

			return (
				<div className={styles.reportOuter}>
					<div className={styles.navOuter}>
						<Breadcrumbs
							schoolState={schoolState}
							tab={tab}
							user={user}
							pageData={pageData}
							forReport={true}
						/>
						{this.makeNav()}
					</div>
					<div className={styles.reportInner}>
						{this.renderBodyHeader({
							classesData: classes,
							tab: "schools",
						})}
						{schoolsReports}
					</div>
				</div>
			);
		},

		renderSchoolsOrClasses: function() {
			const {tab} = this.props;
			if (tab === "classes") {
				return this.renderClasses();
			} else {
				return this.renderSchools();
			}
		},

		renderBodyHeader: function(props) {
			return (
				<ReportBodyHeader
					user={this.props.user}
					pageData={this.props.pageData}
					filters={this.state}
					updateFilter={this.updateFilter}
					schoolState={this.props.schoolState}
					{...props}
				/>
			);
		},

		updateFilter: function(field, val) {
			if (this.state[field] !== val) {
				this.setState({[field]: val});
			}
		},

		// Navigation only shows current year classes and students It would be too
		// much if we tried to do all students for all years, in fact it is already
		// pretty useless if you have a district with thousands of students showing
		// in the nav.
		makeNav: function() {
			const {pageData, tab, currentYear} = this.props;
			const {schoolID, classID, studentID} = pageData || {};
			const classes = getFormattedData(this.props.classes);
			const students = getFormattedData(this.props.students);
			const pd = _.pick(pageData, [
				"grade",
				"chapter",
				"block",
				"date",
				"type",
			]);
			const nextArrow = (
				<ArrowIcon
					arrowClass={styles.rightArrow}
					direction="right"
					colorName="white"
					type="filled"
					size={0.7}
				/>
			);
			const prevArrow = (
				<ArrowIcon
					arrowClass={styles.leftArrow}
					direction="left"
					colorName="white"
					type="filled"
					size={0.7}
				/>
			);
			let prevEl, nextEl, navEl;
			const currentYearClasses = _.filter(classes, c => c.year === currentYear);
			const currentYearStudents = _.filter(
				students,
				c => c.year === currentYear
			);
			if (classID) {
				// Don't show nav if old or deactivated class
				const theClass = classes[classID];
				if (!theClass || !theClass.activeAndCurrent) {
					return null;
				}
			}
			if (schoolID || classID || studentID) {
				let overall, linkToNext, linkToPrev, adjFunc;
				if (schoolID) {
					overall = ClassesUtil.getSchoolsFromOverall(
						currentYearClasses || currentYearStudents
					);
					adjFunc = getAdjacentSchools;
				} else if (classID) {
					overall = currentYearClasses;
					overall = _.filter(overall, oc => oc.activeAndCurrent);
					adjFunc = getAdjacentClasses;
				} else if (studentID) {
					overall = currentYearStudents;
					overall = _.filter(overall, os => !os.inactive);
					adjFunc = getAdjacentStudents;
				}
				const {nextID, prevID, nextName, prevName} = adjFunc(
					schoolID || classID || studentID,
					overall
				);
				if (schoolID) {
					linkToNext = URLMake.forSchool("reports", tab, {
						schoolID: nextID,
					});
					linkToPrev = URLMake.forSchool("reports", tab, {
						schoolID: prevID,
					});
				} else if (classID) {
					linkToNext = URLMake.forClassReport(nextID, pd);
					linkToPrev = URLMake.forClassReport(prevID, pd);
				} else if (studentID) {
					linkToNext = URLMake.forStudentReport(nextID, pd);
					linkToPrev = URLMake.forStudentReport(prevID, pd);
				}
				if (nextID) {
					nextEl = (
						<Link to={linkToNext} className={styles.navLink}>
							<HoverText
								text={nextName}
								size="large"
								direction="bR"
								className={styles.navText}
							>
								{nextName}
							</HoverText>
							{nextArrow}
						</Link>
					);
				}
				if (prevID) {
					prevEl = (
						<Link to={linkToPrev} className={styles.navLink}>
							{prevArrow}
							<HoverText
								text={prevName}
								size="large"
								direction="bR"
								className={styles.navText}
							>
								{prevName}
							</HoverText>
						</Link>
					);
				}
				navEl = (
					<div className={styles.nav}>
						{prevEl}
						{nextEl}
					</div>
				);
			}
			return navEl;
		},

		render: function() {
			const {
				tab,
				user,
				pageData,
				classes,
				students,
				currentYear,
				schoolState,
			} = this.props;
			const {yearFilter} = this.state;
			const {classID, studentID} = pageData;
			const year = (yearFilter && parseInt(yearFilter)) || currentYear;

			const reportsLoad = () => {
				const isStudents = tab === "students";
				let classIDs = [];
				let studentIDs = [];
				if (classID) {
					classIDs = [classID];
					studentIDs = _.map(
						OpsSchool.getStudentsForClass(schoolState, classID),
						s => s.id
					);
				} else if (studentID) {
					studentIDs = [studentID];
				} else {
					const classesForYear = OpsSchool.getClassesForStaffForYear(
						schoolState,
						user.userID,
						year
					);
					classIDs = _.map(classesForYear, c => c.id);
					studentIDs = _.uniq(
						_.flatMap(classIDs, cid =>
							_.map(OpsSchool.getStudentsForClass(schoolState, cid), s => s.id)
						)
					);
				}
				return (
					<LoadGuard
						identifier={isStudents ? "reportStudents" : "reportClasses"}
						status={isStudents ? students : classes}
						requestLoad={
							isStudents
								? () => this.loadStudents(studentIDs)
								: () => this.loadClasses(classIDs)
						}
						loadingView={"logo"}
						logoColorType={"white"}
						loadingViewClass={styles.loading}
						errorView="refreshOffice"
						renderLoaded={
							isStudents ? this.renderStudents : this.renderSchoolsOrClasses
						}
						multiSlotIDs={isStudents ? studentIDs : classIDs}
					/>
				);
			};

			// We're also loading all the accounts info here so we can use it in a lot of places in reports.
			const renderFunc =
				tab === "students" || classID || studentID
					? () => {
							return (
								<LoadGuard
									identifier="accountsMainStudents"
									status={this.props.studentsAccountLoad}
									requestLoad={this.loadAccountStudents}
									loadingView={"logo"}
									logoColorType={"color"}
									errorView="refreshOffice"
									renderLoaded={reportsLoad}
								/>
							);
					  }
					: reportsLoad;
			const content = (
				<LoadGuard
					identifier="accountsMain"
					status={this.props.mainAccountLoad}
					requestLoad={this.loadAccountMain}
					loadingView={"logo"}
					logoColorType={"color"}
					errorView="refreshOffice"
					renderLoaded={renderFunc}
				/>
			);
			const staffRoles = _.get(user, "model.staffRoles");
			const notice =
				!staffRoles || staffRoles.purchaseActive ? null : (
					<div className={styles.notice}>
						{CopyTable.getPurchaseInactiveCopy(null, staffRoles.adminPurchase)}
					</div>
				);

			const problemModal = this.state.showProblemModal ? (
				<OfficeModal
					modalClass={styles.problemsModal}
					closeClass={styles.modalClose}
					closeColor="white"
					onClose={this.onClose}
					closeOnEsc={true}
					portalContainer={null}
					level="overBar"
					closeOnBackdropClick={true}
					isScrollable={true}
					isFixed={true}
				>
					<ReportProblems user={user} {...this.state.showProblemProps} />
				</OfficeModal>
			) : null;

			return (
				<div className={styles.main}>
					{notice}
					{content}
					{problemModal}
				</div>
			);
		},
	})
);
